import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Sponsors = () => {
  const settings = {
    arrows: false,
    infinite: true,
    dots: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    autplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <Slider {...settings} className="pb-4">
      <div>
        <img src={"/assets/logo_carlsberg.png"} className="mx-auto w-56" alt="Sponsor" />
      </div>
      <div>
        <img src={"/assets/nato-logo.png"} className="mx-auto w-48" alt="Sponsor" />
      </div>
      <div>
        <img src={"/assets/logo_visit_sa.png"} className="mx-auto w-52" alt="Sponsor" />
      </div>
      <div>
        <img src={"/assets/voda-leda.png"} className="mx-auto w-48" alt="Sponsor" />
      </div>
      <div>
        <img src={"/assets/novo-sarajevo.png"} className="mx-auto w-52" alt="Sponsor" />
      </div>
      <div>
        <img src={"/assets/logo_argeta.png"} className="mx-auto w-[12.5rem]" alt="Sponsor" />
      </div>
      <div>
        <img src={"/assets/logo_grad_sarajevo.png"} className="mx-auto w-60" alt="Sponsor" />
      </div>
      <div>
        <img src={"/assets/logo_sec_one.png"} className="mx-auto w-40" alt="Sponsor" />
      </div>
      <div>
        <img src={"/assets/mks.png"} className="w-72 md:mx-auto" alt="Sponsor" />
      </div>
      <div>
        <img src={"/assets/FMROI.png"} className="mx-auto w-52" alt="Sponsor" />
      </div>
      <div>
        <img src={"/assets/finefood.png"} className="mx-auto w-36" alt="Sponsor" />
      </div>
      <div>
        <img src={"/assets/cedevita.png"} className="mx-auto w-56" alt="Sponsor" />
      </div>
      <div>
        <img src={"/assets/fmks.png"} className="mx-auto w-52" alt="Sponsor" />
      </div>
      <div>
        <img src={"/assets/geely.png"} className="mx-auto w-40" alt="Sponsor" />
      </div>
    </Slider>
  );
};

export default Sponsors;
